import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacySubscription extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={false} pageTitle={"Subscription"} formname={"table_38"} customClass={"field-customization-container"} />
        );
    }
}

export default LegacySubscription;
